// Generated by purs version 0.13.0
"use strict";
var Data_Array = require("../Data.Array/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Halogen_HTML_Core = require("../Halogen.HTML.Core/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var Halogen_HTML_Properties = require("../Halogen.HTML.Properties/index.js");
var Ritoppu_Model_Creature = require("../Ritoppu.Model.Creature/index.js");
var Ritoppu_Model_CreatureType = require("../Ritoppu.Model.CreatureType/index.js");
var Ritoppu_Model_Equipment = require("../Ritoppu.Model.Equipment/index.js");
var Ritoppu_Model_FovMask = require("../Ritoppu.Model.FovMask/index.js");
var Ritoppu_Model_Item = require("../Ritoppu.Model.Item/index.js");
var Ritoppu_Model_Stage = require("../Ritoppu.Model.Stage/index.js");
var Ritoppu_Model_Tile = require("../Ritoppu.Model.Tile/index.js");
var div_ = function (props) {
    return function (classes) {
        return Halogen_HTML_Elements.div(Data_Semigroup.append(Data_Semigroup.semigroupArray)(props)([ Halogen_HTML_Properties.class_(Data_Newtype.wrap(Halogen_HTML_Core.newtypeClassName)(classes)) ]));
    };
};
var div = function (classes) {
    return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_(Data_Newtype.wrap(Halogen_HTML_Core.newtypeClassName)(classes)) ]);
};
var creatureClass = function (v) {
    if (v instanceof Ritoppu_Model_CreatureType.RedNagaHatchling) {
        return "-red_naga_hatchling";
    };
    if (v instanceof Ritoppu_Model_CreatureType.RedNaga) {
        return "-red_naga";
    };
    throw new Error("Failed pattern match at Ritoppu.Display (line 63, column 17 - line 65, column 25): " + [ v.constructor.name ]);
};
var itemClass = function (v) {
    if (v instanceof Ritoppu_Model_Item.Corpse) {
        return "creature -corpse " + creatureClass(v.value0);
    };
    if (v instanceof Ritoppu_Model_Item.HealingPotion) {
        return "item -healing_potion";
    };
    if (v instanceof Ritoppu_Model_Item.LightningScroll) {
        return "item -lightning_scroll";
    };
    if (v instanceof Ritoppu_Model_Item.FireballScroll) {
        return "item -fireball_scroll";
    };
    if (v instanceof Ritoppu_Model_Item.ConfusionScroll) {
        return "item -confusion_scroll";
    };
    if (v instanceof Ritoppu_Model_Item.MainHandItem && v.value0 instanceof Ritoppu_Model_Equipment.Dagger) {
        return "item -dagger";
    };
    if (v instanceof Ritoppu_Model_Item.MainHandItem && v.value0 instanceof Ritoppu_Model_Equipment.Sword) {
        return "item -sword";
    };
    if (v instanceof Ritoppu_Model_Item.OffHandItem) {
        return "item -shield";
    };
    throw new Error("Failed pattern match at Ritoppu.Display (line 69, column 13 - line 77, column 39): " + [ v.constructor.name ]);
};
var buildElem = function (props) {
    return function (stage) {
        return function (pos) {
            var tile = Ritoppu_Model_Stage.tileAt(stage)(pos);
            var displayTile = function ($$var) {
                return function (v) {
                    if (v instanceof Ritoppu_Model_Tile.Floor) {
                        return div_(props(pos))("tile -floor" + $$var);
                    };
                    if (v instanceof Ritoppu_Model_Tile.Wall) {
                        return div_(props(pos))("tile -wall" + $$var);
                    };
                    if (v instanceof Ritoppu_Model_Tile.StairsDown) {
                        return div_(props(pos))("tile -stairs_down" + $$var);
                    };
                    if (v instanceof Ritoppu_Model_Tile.StairsUp) {
                        return div_(props(pos))("tile -stairs_up" + $$var);
                    };
                    throw new Error("Failed pattern match at Ritoppu.Display (line 56, column 21 - line 60, column 60): " + [ v.constructor.name ]);
                };
            };
            var $10 = {
                creature: Ritoppu_Model_Stage.creatureAt(stage)(pos),
                item: Ritoppu_Model_Stage.itemAt(stage)(pos)
            };
            if (!Ritoppu_Model_FovMask.isSeenTile(stage.fovMask)(pos)) {
                return div("tile -nothing")([  ]);
            };
            if (!Ritoppu_Model_FovMask.isVisibleTile(stage.fovMask)(pos)) {
                return displayTile(" -seen")(tile)([  ]);
            };
            if ($10.creature instanceof Data_Maybe.Just) {
                return displayTile("")(tile)([ Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_(Data_Newtype.wrap(Halogen_HTML_Core.newtypeClassName)("creature " + creatureClass($10.creature.value0.type))), Halogen_HTML_Properties.title(Ritoppu_Model_Creature.creatureName($10.creature.value0)) ])([  ]) ]);
            };
            if (Ritoppu_Model_Stage.playerAt(stage)(pos) && stage.player.stats.hp <= 0) {
                return displayTile("")(tile)([ div("creature -player -corpse")([  ]) ]);
            };
            if (Ritoppu_Model_Stage.playerAt(stage)(pos)) {
                return displayTile("")(tile)([ div("creature -player")([  ]) ]);
            };
            if ($10.item instanceof Data_Maybe.Just) {
                return displayTile("")(tile)([ div(itemClass($10.item.value0))([  ]) ]);
            };
            return displayTile("")(tile)([  ]);
        };
    };
};
var build = function (props) {
    return function (stage) {
        return Data_Functor.map(Data_Functor.functorArray)(function (y) {
            return Data_Functor.map(Data_Functor.functorArray)(function (x) {
                return buildElem(props)(stage)({
                    x: x,
                    y: y
                });
            })(Data_Array.range(0)(stage.size.x));
        })(Data_Array.range(0)(stage.size.y));
    };
};
module.exports = {
    build: build
};
